import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { usePageChrome } from '@/contexts/PageChromeContext';
import { useLanguage } from '@/i18n/language-hooks';
import { cn } from '@/lib/utils';
import { Settings2 } from 'lucide-react';
import { Fragment, useState } from 'react';

export const PageEditMenu = () => {
  const { t } = useLanguage();
  const { editMenuExtensions, editMenuBypass } = usePageChrome();
  const [open, setOpen] = useState(false);

  if (editMenuBypass) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              variant='ghost'
              size='icon'
              className={cn(
                'size-7 shrink-0 cursor-pointer transition-colors',
                'hover:bg-accent hover:text-accent-foreground'
              )}
              aria-label={editMenuBypass.ariaLabel}
              onClick={editMenuBypass.onClick}
            >
              {editMenuBypass.icon}
            </Button>
          </TooltipTrigger>
          <TooltipContent side='bottom'>{editMenuBypass.ariaLabel}</TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  if (editMenuExtensions.length === 0) return null;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <PopoverTrigger asChild>
              <Button
                variant='ghost'
                size='icon'
                className={cn(
                  'size-7 shrink-0 cursor-pointer transition-colors',
                  'hover:bg-accent hover:text-accent-foreground',
                  'data-[state=open]:bg-accent data-[state=open]:text-accent-foreground'
                )}
                aria-label={t('header.editPage')}
              >
                <Settings2 className='size-4' />
              </Button>
            </PopoverTrigger>
          </TooltipTrigger>
          <TooltipContent side='bottom'>{t('header.editPage')}</TooltipContent>
        </Tooltip>
      </TooltipProvider>
      <PopoverContent align='start' className='w-72 space-y-2 p-2'>
        {editMenuExtensions.map(({ key, node }) => (
          <Fragment key={key}>{node}</Fragment>
        ))}
      </PopoverContent>
    </Popover>
  );
};
